<template>
  <span class="d-flex flex-column mt-4" style="gap: 2rem">
    <v-row no-gutters v-for="[datasource, relations] in Object.entries(relationsByDatasource)" :key="datasource">
      <the-relation
        :relations="relations"
        :dataSourceName="datasource"
        :main-datasource-name="dataSourceName"
        :desc-attribute-value="descAttributeValue"
        :featureId="featureId"
        :hover-disabled="allHovered"
      />
    </v-row>
  </span>
</template>
<script>
import { get } from 'vuex-pathify';
import TheRelation from '@/components/TheRelation';
export default {
  name: 'RelationsList',
  components: { TheRelation },
  props: {
    featureId: {
      type: [String, Number],
      required: true,
    },
    descAttributeValue: {
      type: String,
    },
    dataSourceName: {
      type: String,
      required: true,
    },
  },
  computed: {
    relations: get('relations/relations'),
    relationsList() {
      return this.relations?.[this.dataSourceName]?.[this.featureId] || [];
    },
    relationsByDatasource() {
      return this.$_groupByProperty(this.relationsList, 'data_source_name');
    },
  },
  data: () => ({
    allHovered: false,
  }),
  methods: {
    toggleAllRelations(value) {
      this.$root.$emit('toggleFeatureHover', this.relationsList, value);
      this.allHovered = value;
    },
  },
  watch: {
    relationsList: {
      handler() {
        if (this.allHovered) this.toggleAllRelations(true);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.$root.$emit('toggleFeatureHover', null, false);
  },
};
</script>
